"use client";

import { PageVideo } from "@/components/v2/PageVideo";
import { ScrollRow } from "@/components/v2/ScrollRow";
import type { PageVideoItem } from "@/lib/v2/pageVideos";

/** Homepage videos in the same scroller as CardStrip: snap, progress bar, arrows. */
export function VideoStrip({ videos }: { videos: PageVideoItem[] }) {
  return (
    <ScrollRow>
      {videos.map((v, i) => (
        <div key={`${v.id}-${i}`} className="w-[85%] shrink-0 snap-start sm:w-[60%] lg:w-[calc((100%-2rem)/2.5)]">
          <PageVideo video={v} />
          {v.title && <p className="mt-3 line-clamp-2 font-semibold text-ink">{v.title}</p>}
        </div>
      ))}
    </ScrollRow>
  );
}
